import type { FilterParams } from "epsm-api-types";

export const getFilterResult = (filter: FilterParams | undefined) => {
	const groupedFilters =
		filter?.reduce<Record<string, FilterParams>>((acc, item) => {
			if ("name" in item) {
				if (acc[item.name]) {
					acc[item.name].push(item);
				} else {
					acc[item.name] = [item];
				}
			}
			return acc;
		}, {}) || [];

	return Object.values(groupedFilters);
};
